const ToolsHome = {
    initialize: function () {
        const navLinks = document.querySelectorAll('#contentNavigationDrawerSide .menu a');
        for (const navLink of navLinks) {
            navLink.onclick = ToolsHome.submitFilterForm;
        }
    }, 
    submitFilterForm: function(event) {
        const theElement = event.target;
        const theForm = document.getElementById('theFilterForm');
        const anchorEachHandler = function(index, item) {
            if (item.id) {
                var pair = item.id.split(/\|/)
                if (pair.length>=2) {
                    ToolsHome.updateFilter(theForm, pair[0].toLowerCase(), pair[1]);
                }
            }
        }
        
        if (theElement.id) {
            $(theElement).each(anchorEachHandler);
        } else if (theElement.text && theElement.text.trim()=='All') {
            $(theElement.parentElement).find('a').each(anchorEachHandler); 
        } else if (theElement.nextElementSibling && theElement.nextElementSibling.tagName==='UL') {
            $(theElement.nextElementSibling).find('a').each(anchorEachHandler);
        }
        console.debug(`» submitFilterForm(): theForm: `, theForm);
        theForm.submit();
        
        return false;
    }, 
    updateFilter: function(theForm, name, value) {
        if (theForm[name].value.length==0) {
            theForm[name].value = value;
        } else {
            const currentValues = theForm[name].value.split(',');
            if (currentValues.indexOf(value) !== -1) {
                const index = currentValues.indexOf(value);
                if (index>-1) {
                    currentValues.splice(index, 1)
                }
            } else {
                currentValues.push(value);
            }
            theForm[name].value = currentValues.join(',');
        }
    }
}

export default ToolsHome;
